<template>
  <div>
    <div class="py-2" v-if="item.length === 0">
      <img :src="require('@/assets/images/empty.png')" height="300" :width="$isMobile ? '100%' : 300"/>
    </div>
    <div class="pd-c-12" outlined v-for="(itm, idx) in item" :key="idx">
      <v-row v-if="itm.order !== null">
        <v-col cols="12" :md="mini ? 3 : 4" :class="$isMobile ? 'size-13' : ''">
          审核状态：
          <v-chip class="mr-2" dark small :color="itm.order.auditStatus | formatAuditColor">
            {{itm.order.auditStatusVal}}
          </v-chip>
        </v-col>
        <v-col cols="12" :md="mini ? 3 : 4" :class="$isMobile ? 'size-13' : ''">
          退款金额：<span class="font-weight-black">{{itm.money}}</span>
        </v-col>
        <v-col cols="12" :md="mini ? 3 : 4" :class="$isMobile ? 'size-13' : ''">
          退款原因：<span class="font-weight-black">{{itm.refundTypeDic.name}}</span>
        </v-col>
      </v-row>
      <v-row>
         <v-col cols="12" :md="mini ? 3 : 4" :class="$isMobile ? 'size-13' : ''">
          退款编号：<span class="font-weight-black">{{itm.refundNumber}}</span>
        </v-col>
        <v-col cols="12" :md="mini ? 3 : 4" :class="$isMobile ? 'size-13' : ''">
          创建时间：<span class="font-weight-black">{{itm.createTime | formatDay}}</span>
        </v-col>
        <v-col cols="12" :md="mini ? 3 : 4" :class="$isMobile ? 'size-13' : ''">
          退还提成：<span class="font-weight-black">{{itm.isBackMoney === 1 ? '需要' : '不需要'}}</span>
        </v-col>
      </v-row>
      <v-row>
         <v-col cols="12" :md="mini ? 3 : 4" :class="$isMobile ? 'size-13' : ''">
          收款单位：<span class="font-weight-black">{{itm.collectName}}</span>
        </v-col>
        <v-col cols="12" :md="mini ? 3 : 4" :class="$isMobile ? 'size-13' : ''">
          银行账号：<span class="font-weight-black">{{itm.bankAccount}}</span>
        </v-col>
        <v-col cols="12" :md="mini ? 3 : 4" :class="$isMobile ? 'size-13' : ''">
          开户行：<span class="font-weight-black">{{itm.bankType}}</span>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" :class="$isMobile ? 'size-13' : ''">
          备注信息：<span class="font-weight-black">{{itm.remark}}</span>
        </v-col>
      </v-row>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'RefundDetail',
    components: {
    },
    props: {
      item: {
        type: Array,
        default: () => ([])
      },
      mini: {
        type: Boolean,
        default: false
      }
    },
    data() {
      return {
      }
    }
  }
</script>

<style>
</style>
